import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import React from "react";
import { COLORS } from "src/constants/colors";
import { Inspection, InspectionTemplate } from "src/data/types";
import { Template } from "../templates/templateDisplayCard";

type IncompleteInspectionsDisplayCardProps = {
  inspection: Inspection;
};
const IncompleteInspectionsDisplayCard = ({
  inspection,
}: IncompleteInspectionsDisplayCardProps) => {
  return (
    <Column
      type="outline"
      width={158}
      height={87}
      spacingInset="none 300"
      backgroundColor={COLORS.SEMI_TRANSPARENT_WHITE}
      spacing="300"
    >
      <Row>
        <Text type="b300">{inspection.templateName}</Text>
      </Row>
      <Row>
        <Text type="b100">{inspection.siteCode}</Text>
        <Text type="b100">{`${inspection.complianceStats.questionCount} Checks`}</Text>
      </Row>
    </Column>
  );
};

export default IncompleteInspectionsDisplayCard;
